<template>
  <div>
    <div class="form-group row mr-1">
      <div class="col-sm-7 d-flex align-items-center justify-content-end">
        <span class="align-middle"> show</span>
      </div>
      <div class="col-sm-5" style="padding: 0px">
        <b-form-select
          :value="perPage"
          style="height: 35px"
          :options="perPageList"
          @change="perPageChange"
        ></b-form-select>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ShowPagination',
    props: {
      perPage: Number,
    },
    data() {
      return {
        perPageList: [
          { value: 10, text: '10' },
          { value: 20, text: '20' },
          { value: 30, text: '30' },
          { value: 40, text: '40' },
          { value: 50, text: '50' },
          { value: 100, text: '100' },
        ],
      };
    },
    methods: {
      perPageChange(currentPerPage) {
        this.$emit('update', { currentPerPage: currentPerPage });
      },
    },
  };
</script>
